.prose {
  display: flex;
  flex-direction: column;
  gap: var(--gb-space-4);
  max-width: var(--gb-prose);
  font-family: var(--gb-font-text);
  font-size: var(--gb-body);
  line-height: 1.6;
  overflow-wrap: break-word;
}

.documentTitle {
  font-family: var(--gb-font-display);
  font-variation-settings:
    'wdth' 118,
    'wght' 800;
  text-transform: uppercase;
  font-size: clamp(1.5rem, 1.1rem + 1.8vw, 2.25rem);
  line-height: 1;
  letter-spacing: -0.01em;
  margin: 0;
}

.section {
  font-family: var(--gb-font-display);
  font-variation-settings:
    'wdth' 112,
    'wght' 700;
  text-transform: uppercase;
  font-size: var(--gb-lead);
  line-height: 1.15;
  margin: var(--gb-space-6) 0 0;
  padding-top: var(--gb-space-4);
  border-top: var(--gb-rule-width) solid var(--gb-rule);
}

.prose > .section:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

.paragraph {
  margin: 0;
}

.paragraph strong,
.bullets strong {
  font-weight: 600;
  color: var(--gb-text);
}

.bullets {
  margin: 0;
  padding-left: var(--gb-space-6);
  display: flex;
  flex-direction: column;
  gap: var(--gb-space-2);
}

.bullets li {
  padding-left: var(--gb-space-1);
}

.bullets li::marker {
  color: var(--gb-accent);
}
